import { render, staticRenderFns } from "./GroupList.vue?vue&type=template&id=cc21273c&"
import script from "./GroupList.vue?vue&type=script&lang=ts&"
export * from "./GroupList.vue?vue&type=script&lang=ts&"
import style0 from "./GroupList.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports